import ShareButtons from './shareButtons'

const shareButtonsElements = [...document.querySelectorAll('.shareButtons')]
shareButtonsElements.forEach((element) => {
	const shareButtons = new ShareButtons(element)
	shareButtons.init()
})
